import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, map, Observable, of } from "rxjs";

interface Manifest {
  templates: string[];
}

@Injectable({ providedIn: "root" })
export class ManifestService {
  private http: HttpClient = inject(HttpClient);

  private readonly MANIFEST_PATH = "assets/templates/manifest.json" as const;

  getTemplatePaths(): Observable<string[]> {
    return this.loadManifest().pipe(map((manifest) => manifest.templates ?? []));
  }

  private loadManifest(): Observable<Manifest> {
    return this.http.get<Manifest>(this.MANIFEST_PATH).pipe(
      catchError(() => {
        console.warn("[TemplateService] Could not load template manifest");
        return of({ templates: [] });
      }),
    );
  }
}
